module.exports = __webpack_public_path__ + "img/petstairs34.a325b14a.jpg";